module.exports = __webpack_public_path__ + "static/media/icon_network_137.88f32691.png";